/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Change_PhotoInputs */



/**
* | output |
* | --- |
* | "Change photo" |
*
* @param {User_Change_PhotoInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_change_photo = /** @type {((inputs?: User_Change_PhotoInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Change_PhotoInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Changer la photo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar foto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alterar foto")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cambia foto")
	return /** @type {LocalizedString} */ ("Change photo")
});